const highlightCell = (shouldHighlight: boolean): React.CSSProperties => ({
  textDecorationLine: shouldHighlight ? "underline" : "none",
  color: shouldHighlight
    ? "var(--mantine-color-primaryHighlight-0)"
    : "inherit",
  cursor: "pointer",
})

export default highlightCell
